import { useEffect, useState } from 'react'
import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import setToast from "../../helpers/toaster.helper";
import { ActionLabels, ToasterTexts, appNote } from '../shared/constants';
import { ToasterType } from '../shared/toaster/toaster.model';
import SettingsHeader from "./settingsHeader.component";
import { Setting, SettingsModel } from '../../models/settings-model';
import { SettingsService } from "../../services/SettingsService";
import { LoadNotificationStatus, LoadOrgName, UpdateSettings } from "../../actions/index";
import * as selector from "../../selectors/selectors";
import CustomSwitch from '../shared/switch.component';
import { FalkonDocSignerDoneIcon, FalkonSignIcon, SettingsNotificationTeamsIcon, SettingsNotificationWebexIcon } from "../../icon";
import { ProfileModel } from '../../models/profile.model';
import { UserService } from '../../services/UserService';
import { updateActivityFeedNotificationStatus, updateFalkonSignNotificationStatus, updateNotificationStatus, updateWebexNotificationStatus } from '../../reducers/reducer';
import ConfirmDialog from "../shared/confirm-dialog.component";

const NotificationSettings = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const SettingsData: Setting[] = useSelector(selector.settings)
    const SettingsObj: SettingsModel = useSelector(selector.settingsObj)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const IsActivityFeedNotificationInfo: { integrationStatus: boolean; message: string; notificationStatus: boolean; } = useSelector(selector.IsActivityFeedNotificationEnabled)
    const IsNotificationInfo: { phoneNumber: string; userId: string; mobileNotificationStatus: boolean; teamsNotificationStatus: boolean; } = useSelector(selector.IsNotificationEnabled)
    const IsWebexNotificationInfo: { status: boolean; } = useSelector(selector.IsWebexNotificationEnabled)
    const FalkonSignSmsNotification: boolean = useSelector(selector.IsFalkonSignNotificationEnabled)

    const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage()

    const [showDialogue, setShowDialogue] = useState<boolean>(false);
    const [showTeamsDialogue, setShowTeamsDialogue] = useState<boolean>(false);
    const [showWebexDialogue, setShowWebexDialogue] = useState<boolean>(false);
    const [showTeamsBotDialogue, setShowTeamsBotDialogue] = useState<boolean>(false);
    const [showMobilePushDialogue, setShowMobilePushDialogue] = useState<boolean>(false);
    const [showFalkonSignSmsNotificationDialog, setshowFalkonSignSmsNotificationDialog] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [switchType, setSwitchType] = useState<string>("");;
    const [ButtonName, setButtonName] = useState<string>("");


    const handleSwitch = (checked: boolean, type: string) => {
        let text = "";
        switch (type) {
            case "web":
                setShowDialogue(true);
                text = checked
                    ? appNote.NOTIFICATION_ENABLE_MESSAGE
                    : appNote.NOTIFICATION_DISABLE_MESSAGE;
                break;
            case "teams":
                setShowTeamsDialogue(true);
                text = checked
                    ? appNote.TEAMS_NOTIFICATION_ENABLE_MESSAGE
                    : appNote.TEAMS_NOTIFICATION_DISABLE_MESSAGE;
                break;
            case "teamsBot":
                setShowTeamsBotDialogue(true);
                text = checked
                    ? appNote.TEAMSBOT_NOTIFICATION_ENABLE_MESSAGE
                    : appNote.TEAMSBOT_NOTIFICATION_DISABLE_MESSAGE;
                break;
            case "mobilePush":
                setShowMobilePushDialogue(true);
                text = checked
                    ? appNote.MOBILE_PUSH_NOTIFICATION_ENABLE_MESSAGE
                    : appNote.MOBILE_PUSH_NOTIFICATION_DISABLE_MESSAGE;
                break;
            case "webex":
                setShowWebexDialogue(true);
                text = checked
                    ? appNote.WEBEX_NOTIFICATION_ENABLE_MESSAGE
                    : appNote.WEBEX_NOTIFICATION_DISABLE_MESSAGE;
                break;
            case "esign":
                setshowFalkonSignSmsNotificationDialog(true);
                text = checked
                    ? appNote.FALKON_SIGN_NOTIFICATION_ENABLE_MESSAGE
                    : appNote.FALKON_SIGN_NOTIFICATION_DISABLE_MESSAGE;
                break;
            default:
                break;
        }
        openConfirmDialog(text, checked ? ActionLabels.ENABLE : ActionLabels.DISABLE);
    }

    const disableActivityFeed = (): boolean => {
        return IsTeamsApp && IsActivityFeedNotificationInfo.integrationStatus === false
    }

    const openConfirmDialog = (text: any, action: string) => {
        setText(text)
        setButtonName(action)
        setIsLoading(false)
    }

    const handleTeamsSwitch = (status: string, checked: boolean,) => {
        if (IsTeamsApp) {
            SettingsService.updateActivityFeedSetting(status, { "notification_status": !checked }).then(res => {
                dispatch(updateActivityFeedNotificationStatus({ ...IsActivityFeedNotificationInfo, notificationStatus: !checked }))
            })
        }
    }

    const handleTeamsBotSwitch = (id: string, phoneNumber: string, status: boolean, checked: boolean,) => {
        SettingsService.updateNotificationSetting({ "userId": id, "phoneNumber": phoneNumber, "mobileNotificationStatus": status, "teamsNotificationStatus": !checked }).then(res => {
            dispatch(updateNotificationStatus({ phoneNumber: phoneNumber, userId: id, mobileNotificationStatus: status, teamsNotificationStatus: !checked }))
        })
    }

    const handleMobilePushSwitch = (id: string, phoneNumber: string, checked: boolean, status: boolean) => {
        SettingsService.updateNotificationSetting({ "userId": id, "phoneNumber": phoneNumber, "mobileNotificationStatus": !checked, "teamsNotificationStatus": status }).then(res => {
            dispatch(updateNotificationStatus({ phoneNumber: phoneNumber, userId: id, mobileNotificationStatus: !checked, teamsNotificationStatus: status }))
        })
    }

    const handleFalkonSignSmsNotificationSwitch = (status: boolean) => {
        SettingsService.updateFalkonSignSmsNotifcationStatus(status).then(res => {
            dispatch(updateFalkonSignNotificationStatus(status))
            setToast(status ? "Notifications enabled successfully" : "Notifications disabled successfully", ToasterType.SUCCESS)
        }).catch((err) => {
            setToast("updating notification status failed", ToasterType.DANGER)
        })
    }

    const handleWebexSwitch = (email: string, checked: boolean) => {
        SettingsService.updateWebexSetting({ email: email, status: !checked })
            .then(res => {
                dispatch(updateWebexNotificationStatus({ status: !checked }));
                const btnLabel = ButtonName;
                setToast(
                    btnLabel === ActionLabels.ENABLE
                        ? ToasterTexts.WEBEX_NOTIFICATION_ON
                        : ToasterTexts.WEBEX_NOTIFICATION_OFF,
                    ToasterType.SUCCESS
                );
            })
            .catch(error => {
                setToast(
                    ToasterTexts.WEBEX_NOTIFICATION_FAILURE,
                    ToasterType.DANGER
                );
                setIsLoading(false);
            });
    };

    const closeConfirmDialog = (isConfirm: boolean, dialogType: string) => {
        let btnLabel = ButtonName;

        if (isConfirm) {
            setIsLoading(true);

            switch (dialogType) {
                case "web":
                    setShowDialogue(false);
                    let setting = SettingsData.find((x) => x.Code === SettingsService.Notification_Code);
                    if (setting) {
                        UpdateSettings(dispatch, {
                            id: setting.ID,
                            name: setting.Name,
                            code: setting.Code,
                            value: btnLabel === ActionLabels.ENABLE ? "true" : "false",
                        });
                        setToast(
                            btnLabel === ActionLabels.ENABLE
                                ? ToasterTexts.NOTIFICATION_ON
                                : ToasterTexts.NOTIFICATION_OFF,
                            ToasterType.SUCCESS
                        );
                    }
                    break;

                case "teams":
                    setShowTeamsDialogue(false);
                    const id = localStorage.getItem("activityInfo") && JSON.parse(localStorage.getItem("activityInfo")!)?.userId
                    handleTeamsSwitch(id, IsActivityFeedNotificationInfo.notificationStatus)
                    setToast(
                        btnLabel === ActionLabels.ENABLE
                            ? ToasterTexts.ACTIVITY_FEED_NOTIFICATION_ON
                            : ToasterTexts.ACTIVITY_FEED_NOTIFICATION_OFF,
                        ToasterType.SUCCESS
                    );
                    break;

                case "teamsBot":
                    setShowTeamsBotDialogue(false);
                    const userId = JSON.parse(localStorage.getItem("current-user")?.toString()!)?.id;
                    const phoneNumber = JSON.parse(localStorage.getItem("current-user")?.toString()!)?.phoneNumber;
                    handleTeamsBotSwitch(userId, phoneNumber, IsNotificationInfo.mobileNotificationStatus, IsNotificationInfo.teamsNotificationStatus)
                    setToast(
                        btnLabel === ActionLabels.ENABLE
                            ? ToasterTexts.TEAMS_BOT_NOTIFICATION_ON
                            : ToasterTexts.TEAMS_BOT_NOTIFICATION_OFF,
                        ToasterType.SUCCESS
                    );
                    break;

                case "webex":
                    setShowWebexDialogue(false);
                    const userEmail = JSON.parse(localStorage.getItem("current-user")?.toString()!)?.email;
                    handleWebexSwitch(userEmail, IsWebexNotificationInfo.status)
                    break;

                case "mobilePush":
                    setShowMobilePushDialogue(false);
                    const Id = JSON.parse(localStorage.getItem("current-user")?.toString()!)?.id;
                    const phonenumber = JSON.parse(localStorage.getItem("current-user")?.toString()!)?.phoneNumber;
                    handleMobilePushSwitch(Id, phonenumber, IsNotificationInfo.mobileNotificationStatus, IsNotificationInfo.teamsNotificationStatus)
                    setToast(
                        btnLabel === ActionLabels.ENABLE
                            ? ToasterTexts.MOBILE_PUSH_NOTIFICATION_ON
                            : ToasterTexts.MOBILE_PUSH_NOTIFICATION_OFF,
                        ToasterType.SUCCESS
                    );
                    break;
                case "esign":
                    setshowFalkonSignSmsNotificationDialog(false);
                    handleFalkonSignSmsNotificationSwitch(!FalkonSignSmsNotification)
                    break;
                default:
                    break;
            }
        } else {
            switch (dialogType) {
                case "web":
                    setShowDialogue(false);
                    break;
                case "teams":
                    setShowTeamsDialogue(false);
                    break;
                case "teamsBot":
                    setShowTeamsBotDialogue(false);
                    break;
                case "webex":
                    setShowWebexDialogue(false);
                    break;
                case "mobilePush":
                    setShowMobilePushDialogue(false);
                    break;
                case "esign":
                    setshowFalkonSignSmsNotificationDialog(false);
                    break;
                default:
                    break;
            }
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!UserService.hasSysAdminRole()) {
            LoadNotificationStatus(dispatch)
        }
    }, [])


    return (
        <>
            <div className={`m-auto`}>
                <div className={`d-flex flex-direction w-p-100 ${IsMobileDevice ? "" : "mt-2"}`}>
                    <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Notification Settings"} subTitle={appNote.NOTIFICATION_SETTINGS_MESSAGE} />
                </div>
                <div className={`${IsMobileDevice ? 'py-3 px-3' : ''} `}>
                    <div className="mb-2">
                        <div>
                            <Grid container>
                                <Grid item className="t-align-left d-flex  mb-1 my-auto">
                                    <Typography className=" h5-medium t-align-left">
                                        Web / Desktop App Notification
                                    </Typography>
                                </Grid>
                                <Grid item className="b-none my-auto ml-auto" >
                                    <CustomSwitch
                                        checked={SettingsObj.NotificationsEnabled}
                                        onChange={(checked: boolean) => handleSwitch(checked, "web")}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        {/* <div className='mt-2'>
                            <Grid container>
                                <Grid item className="t-align-left d-flex  mb-1 my-auto">
                                    <Typography className=" h5-medium t-align-left">
                                        Mobile Push Notification
                                    </Typography>
                                </Grid>
                                <Grid item className="b-none my-auto ml-auto" >
                                    <CustomSwitch
                                        checked={IsNotificationInfo.mobileNotificationStatus}
                                        onChange={(checked: boolean) => handleSwitch(checked, "mobilePush")}
                                    />
                                </Grid>
                            </Grid>
                        </div> */}
                    </div>
                    <hr className="unsubscribe-hr opacity-1 mt-1 "></hr>
                    <div className='mt-2'>
                        <div className=' d-flex align-center' style={{ gap: "10px" }}>
                            <SettingsNotificationTeamsIcon />
                            <span className='h3-semibold'>Teams</span>
                        </div>
                        {!!IsTeamsApp && <div className='mt-2'>
                            <Grid container>
                                <Grid item className="t-align-left d-flex  mb-1 my-auto">
                                    <Typography className=" h5-medium t-align-left">
                                        Teams Notification
                                    </Typography>
                                </Grid>
                                <Grid item className="b-none my-auto ml-auto" >
                                    <CustomSwitch
                                        disabled={disableActivityFeed()}
                                        checked={IsActivityFeedNotificationInfo.notificationStatus}
                                        onChange={(checked: boolean) => handleSwitch(checked, "teams")}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        }
                        <div className='mt-2'>
                            <Grid container>
                                <Grid item className="t-align-left d-flex  mb-1 my-auto">
                                    <Typography className=" h5-medium t-align-left">
                                        Teams Bot Notification
                                    </Typography>
                                </Grid>
                                <Grid item className="b-none my-auto ml-auto" >
                                    <CustomSwitch
                                        checked={IsNotificationInfo.teamsNotificationStatus}
                                        onChange={(checked: boolean) => handleSwitch(checked, "teamsBot")}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <hr className="unsubscribe-hr opacity-1 mt-1 "></hr>
                    <div className='mt-2'>
                        <div className=' d-flex align-center' style={{ gap: "10px" }}>
                            <SettingsNotificationWebexIcon />
                            <span className='h3-semibold'>Webex</span>
                        </div>
                        <div className='mt-2'>
                            <Grid container>
                                <Grid item className="t-align-left d-flex  mb-1 my-auto">
                                    <Typography className=" h5-medium t-align-left">
                                        Webex Notification
                                    </Typography>
                                </Grid>
                                <Grid item className="b-none my-auto ml-auto" >
                                    <CustomSwitch
                                        checked={IsWebexNotificationInfo.status}
                                        onChange={(checked: boolean) => handleSwitch(checked, "webex")}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <hr className="unsubscribe-hr opacity-1 mt-1 "></hr>
                    <div className='mt-2'>
                        <div className=' d-flex align-center' style={{ gap: "10px" }}>
                            <FalkonSignIcon />
                            <span className='h3-semibold'>Falkon Sign</span>
                        </div>
                        <div className='mt-2'>
                            <Grid container>
                                <Grid item className="t-align-left d-flex  mb-1 my-auto">
                                    <Typography className=" h5-medium t-align-left">
                                        SMS Notification
                                    </Typography>
                                </Grid>
                                <Grid item className="b-none my-auto ml-auto" >
                                    <CustomSwitch
                                        checked={FalkonSignSmsNotification}
                                        onChange={(checked: boolean) => handleSwitch(checked, "esign")}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
                {showDialogue &&
                    <ConfirmDialog
                        onClose={(isConfirm) => closeConfirmDialog(isConfirm, "web")}
                        Show={showDialogue}
                        Text={text}
                        ButtonName={ButtonName}
                        Loading={isLoading}
                        IsMobileDevice={IsMobileDevice}
                    />
                }
                {showTeamsDialogue &&
                    <ConfirmDialog
                        onClose={(isConfirm) => closeConfirmDialog(isConfirm, "teams")}
                        Show={showTeamsDialogue}
                        Text={text}
                        ButtonName={ButtonName}
                        Loading={isLoading}
                        IsMobileDevice={IsMobileDevice}
                    />
                }
                {showWebexDialogue &&
                    <ConfirmDialog
                        onClose={(isConfirm) => closeConfirmDialog(isConfirm, "webex")}
                        Show={showWebexDialogue}
                        Text={text}
                        ButtonName={ButtonName}
                        Loading={isLoading}
                        IsMobileDevice={IsMobileDevice}
                    />
                }
                {showTeamsBotDialogue &&
                    <ConfirmDialog
                        onClose={(isConfirm) => closeConfirmDialog(isConfirm, "teamsBot")}
                        Show={showTeamsBotDialogue}
                        Text={text}
                        ButtonName={ButtonName}
                        Loading={isLoading}
                        IsMobileDevice={IsMobileDevice}
                    />
                }

                {showMobilePushDialogue &&
                    <ConfirmDialog
                        onClose={(isConfirm) => closeConfirmDialog(isConfirm, "mobilePush")}
                        Show={showMobilePushDialogue}
                        Text={text}
                        ButtonName={ButtonName}
                        Loading={isLoading}
                        IsMobileDevice={IsMobileDevice}
                    />
                }

                {showFalkonSignSmsNotificationDialog &&
                    <ConfirmDialog
                        onClose={(isConfirm) => closeConfirmDialog(isConfirm, "esign")}
                        Show={showFalkonSignSmsNotificationDialog}
                        Text={text}
                        ButtonName={ButtonName}
                        Loading={isLoading}
                        IsMobileDevice={IsMobileDevice}
                    />
                }
            </div>
        </>
    )
}

export default NotificationSettings